import React, { Component } from 'react';
import { API_URL } from '../../constants/api';
import { apiBatchRequest, apiPost } from '../../utils/api_service';
import { ShowToast, toastType } from '../../utils/toast-service';
import commonLabels from '../../constants/messageConstants';
import PageHeader from '../common/PageHeader';
import PageFilter from '../common/PageFilter';
import { GridTable } from '../common/Table/Table';
import { applyFilterOnData, cloneDeep, UpdateColumnWithConfiguration } from '../../utils/helper';
import { closeYearEndBonusColumn } from '../../constants/MockData';
import { IconButton, Tooltip } from '@material-ui/core';
import { controlType } from '../../constants/common';
import _, { update } from 'lodash';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import ConfirmDialog from '../common/Dailogbox/confirmDailog';

// Component used to Close Year End Bonus periods
export class CloseYearEndBonus extends Component {
  // Constructor to set initial state of component
  constructor () {
    super();
    this.state = {
      yearEndBonusMasterData: [],
      yearEndBonusData: [],
      selectedData: [],
      responseYearEndBonusData: [],
      isPopupOpen: false,
      confirmationMessage: '',
      updateData: undefined,
      configuration: [],
      isBack: false
    };
  }

  // Get data from APIs before components are mounted
  componentDidMount () {
    window.scrollTo(0, 0);
    this.LoadData();
  }

  // Handle filter value change event
  onFilterChange = (selectedData) => {
    const { responseYearEndBonusData } = this.state;
    this.setState({ yearEndBonusData: applyFilterOnData(_.cloneDeep([...responseYearEndBonusData]), selectedData), selectedData: selectedData });
  };

  // Load master data from DB using API calls
  LoadData () {
    this._asyncRequest = apiBatchRequest([
      {
        url: API_URL.Users.GetYearEndBonusConfiguration + '?yearEndBonusConfigurationId=' + 0 + '&year=' + 0,
        key: 'yearEndBonusData'
      }
    ])
      .then(
        ({
          yearEndBonusData
        }) => {
          this._asyncRequest = null;
          if (yearEndBonusData.success !== true) {
            ShowToast(
              commonLabels.somethingWrong,
              toastType.ERROR,
              5000,
              500,
              'Server error'
            );
          } else {
            this.setState({
              yearEndBonusData: applyFilterOnData(cloneDeep(yearEndBonusData.data || []), this.state.selectedData),
              responseYearEndBonusData: cloneDeep(yearEndBonusData.data || []),
              yearEndBonusMasterData: cloneDeep(yearEndBonusData.data || []),
              configuration: yearEndBonusData.config
            });
          }
        }
      )
      .catch(() => {
        this._asyncRequest = null;
      });
  }

  // Handle event on Confirmation popup
  onPopupClickHandle = (value) => {
    if (value) {
      this.closeYearEndBonus();
    } else {
      this.setState({ isPopupOpen: false, confirmationMessage: '' });
    }
  }

  // Close selected Year End Bonus period
  closeYearEndBonus = () => {
    const { updateData } = this.state;

    const params = {
      year: updateData.processYear,
      isClosed: true
    };
    apiPost({
      url: API_URL.Users.CloseYearEndBonus,
      params: params
    }).then(({ data: response }) => {
      if (response.success) {
        ShowToast('Year End Bonus Period Closed Successfully.', toastType.SUCCESS, 5000, 500);
        this.setState({ isPopupOpen: false, confirmationMessage: '', isPreviousToCurrentOrFuture: false, updateData: undefined }, () => { this.LoadData(); });
      } else {
        this.setState({ isPopupOpen: false, confirmationMessage: '', isPreviousToCurrentOrFuture: false, updateData: undefined });
      }
    });
  }

  // Open confirmation dialog box while closing of Pay Period
  EndYearEndBonus = (row) => {
    this.setState({
      isPopupOpen: true,
      confirmationMessage: <span>Are You Sure You Want To Close Year End Bonus: <b>{row.processYear}</b>?</span>,
      updateData: row
    });
  }

  // Render Edit/Save/Cancel action buttons for the every record
  renderActionColumn = (row) => {
    return (
      <>
        { row.isClosed === false
          ? <Tooltip title="Close year end bonus period">
            <IconButton
              aria-label={'refreshData'}
              size="small"
              onClick={() => {
                this.EndYearEndBonus(row);
              }}
            >
              <HighlightOffIcon fontSize="small" size="small" />
            </IconButton>
          </Tooltip>
          : ''
        }
      </>
    );
  };

  // Render components based on conditions
  render () {
    const { yearEndBonusData, selectedData, isPopupOpen, confirmationMessage } = this.state;
    return (
      <>
        {isPopupOpen && (
          <ConfirmDialog
            IsOpen={isPopupOpen}
            Message={confirmationMessage}
            Title="Confirm"
            OnHandelClick={(isValid) => {
              if (isValid) {
                this.onPopupClickHandle(isValid);
              } else {
                this.onPopupClickHandle(isValid);
              }
            }}
            AgreeText="Close Year End Bonus"
            DisAgreeText="Cancel"
          />
        )}
        {<>
          <PageHeader title="Close Year End Bonus Period"></PageHeader>
          <PageFilter
            hidePanel={true}
            autoFilter={false}
            filterAlwaysVisible={true}
            onFilterChanged={this.onFilterChange}
            filterConfig={[
              {
                type: controlType.Year,
                key: 'processYear',
                placeholder: 'Process Year',
                title: 'Year',
                ignoreSort: true
              }
            ]}
            gridColumn={3}
            defaultSelectedData={[]}
            selectedData={selectedData}
          ></PageFilter>

          <div className="row table-list-container">
            <GridTable
              columns={UpdateColumnWithConfiguration(
                closeYearEndBonusColumn,
                this.state.configuration
              )}
              data={yearEndBonusData || []}
              renderActionColumn={this.renderActionColumn}
            ></GridTable>
          </div>
        </>}
      </>
    );
  }
}

export default CloseYearEndBonus;
